import { render, staticRenderFns } from "./u-btn-icon-flat-rounded.vue?vue&type=template&id=5c6d4cf3&scoped=true&"
import script from "./u-btn-icon-flat-rounded.vue?vue&type=script&lang=js&"
export * from "./u-btn-icon-flat-rounded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6d4cf3",
  null
  
)

export default component.exports